/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Vendor_Return_Waiting_On_OperationsInputs */

const en_vendor_return_waiting_on_operations = /** @type {(inputs: Vendor_Return_Waiting_On_OperationsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Operations · the supplier's refusal · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Operations · the supplier's refusal · since {since}" |
*
* @param {Vendor_Return_Waiting_On_OperationsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_waiting_on_operations = /** @type {((inputs: Vendor_Return_Waiting_On_OperationsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Waiting_On_OperationsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_waiting_on_operations(inputs)
});